import React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import Home from "./pages/Home/Home"
import Jobs from "./pages/Jobs/Jobs"
import JobDescription from "./pages/JobDescription/JobDescription"
import "./styles/styles.css"

function App() {
  return (
    <BrowserRouter>
      <Navbar/>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="jobs">
                <Route index element={<Jobs />} />
                <Route path=":id" element={<JobDescription />} />
              </Route>
          </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
